import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { AppService } from '../app.service';
import { ADMIN_CONSTANT } from '../app.model';
import { DashboardService } from './dashboard.service';

@Injectable()
export class DashboardResolver implements Resolve<any> {
  constructor(
    private service: AppService,
    private dashService: DashboardService
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return this.service.onUserAdminLandingFetch().pipe(
      map((response) => {
        if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
          this.dashService.userInfo.next(response.Body.BusinessData.UserInfo)
          this.dashService.userMenu.next(response.Body.BusinessData.UserMenu);
          this.dashService.userScreen.next(
            response.Body.BusinessData.UserScreen
          );
          this.dashService.organizations.next(response.Body.MasterData.Org);
          this.dashService.institutions.next(response.Body.MasterData.Inst);
          this.dashService.countries.next(response.Body.MasterData.Country);
          this.dashService.states.next(response.Body.MasterData.State);
          this.dashService.districts.next(response.Body.MasterData.District);
          this.dashService.universities.next(response.Body.MasterData.University);
          this.dashService.collegetypes.next(response.Body.MasterData.CollegeType);
          this.dashService.depertments.next(
            response.Body.MasterData.Department
          );
          this.dashService.academicClasses.next(response.Body.MasterData.Class);
          this.dashService.academicSessions.next(
            response.Body.MasterData.AcademicSession
          );
          this.dashService.subjects.next(response.Body.MasterData.Subject);
          this.dashService.universities.next(response.Body.MasterData.University);
          this.dashService.collegeTypes.next(response.Body.MasterData.CollegeType);
          this.dashService.colleges.next(response.Body.MasterData.College);
          this.dashService.namePrefix.next(response.Body.MasterData.NamePrefix);
          this.dashService.gender.next(response.Body.MasterData.Gender);
          this.dashService.transportRoutes.next(response.Body.MasterData.Route);
          this.dashService.runCycles.next(response.Body.MasterData.RunCycle);

          // set session stotage for menu screen
          this.service.setToken(
            ADMIN_CONSTANT.ADMIN_TOKEN_ADMIN_USER_MENU_SCREEN,
            response.Body.BusinessData.UserScreen
          );
        }
        return response;
      })
    );
  }
}
